import getConfig from 'next/config';
import Fetch from 'fetch-ponyfill';

const { fetch } = Fetch();

const { publicRuntimeConfig } = getConfig();
const defaultLogUrl = 'https://frontend-m.binance.cloud/monitor/v1/log';

const { logUrl, commit } = publicRuntimeConfig;

const logError = (payload) => {
  const watchdogPayload = {
    ...payload,
    versionCode: commit,
    clienttype: typeof window === 'undefined' ? 'SSR' : 'Browser',
  };
  fetch(logUrl || defaultLogUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(watchdogPayload),
  });
};

export default logError;
